import Storage from "./storage";
import { history } from "../shared/configure-store"


class AuthHelper {

    static setLogin = (resp) => {

        Storage.set('access_token', resp.access_token);

        Storage.set('expired_at', resp.expires_in);

    };

    static setLoginReg = (resp) => {

        Storage.set('access_token', resp.token);

    };

    static setProfile = (resp) => {

        Storage.set('profile', resp);

    };

    static getPayment = () => {

        return Storage.get('payment');

    };

    static setPayment = (resp) => {

        Storage.set('payment', resp);

    };

    static getProfile() {

        return Storage.get('profile');

    };

    static setLang = (lang) => {

        Storage.set('language',lang);

    };

    static getLang() {

        let lang = Storage.get('language');

        if(lang === null) {
            lang = 'indo';
        }else {
            lang = Storage.get('language');
        }
        return lang;

    };

    static logOut() {

        Storage.clear();

        history.push('/login');

    };

    static isLoggedIn() {

        return !!Storage.get('access_token');

    };

}

export default AuthHelper;
